<div class="steps-progress">
  <div class="steps-progress__label">{{ 'COMMON.step_of' | translate:{current, count: steps} }}</div>
  <div class="steps-progress__slider">
    <div class="steps-progress__slider-value" [style.width.%]="sliderWidth"></div>
  </div>
</div>